import request from '@/utils/request'
import { downloadBlob } from '@/utils/helpers'
import uuid from 'uniq-id'

export default {
    getCustomers: async({ commit, dispatch }, params) => {
        await request({
            method: 'get',
            url: 'customers',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...params
            }
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })

                commit('SET_CUSTOMERS', res.data.items)
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    resetLoginAttempts: async({ dispatch }, { phoneNumber }) => {
        return request({
            method: 'post',
            url: `customers/reset-login-attempts/${phoneNumber}`
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        })
    },

    getCustomerById: async({ commit, dispatch }, id) => {
        return request({
            method: 'get',
            url: `customers/${id}`
        }).then(res => {
            if (res.data) {
                return res.data
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        })
    },

    updateCustomer: async({ commit, dispatch }, data) => {
        return await request({
            method: 'put',
            url: `customers/${data.id}`,
            data
        }).then(res => {
            if (res.data) {
                dispatch('addMessage', {
                    type: 'success',
                    message: 'updated',
                    locale: true
                }, { root: true })
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.data.message
            }, { root: true })
        })
    }
}
